import React from 'react';
import { Textarea, ValidationProps } from 'ui';
import { SHORT_DEBOUNCE_TIME } from 'app/components/translation/constants';
import { GroupText } from 'app/components/group-text/group-text';

import { CompanyReportAdminTranslation } from '../../constants';
import { savedReportCellMaxLength, savedReportRangeMaxLength } from './constants';

import styles from './saved-report-cell-range.scss';

const cell = 'cell';
const range = 'range';

export const getFieldId = (id: string, fieldName: string) => `${id}_${fieldName}`;

interface SavedReportCellRangeProps {
  id: string;
  title: string;
  cellRequired: boolean;
  cellValue: string;
  rangeValue: string;
  onUpdateCell: (value: string) => void;
  onUpdateRange: (value: string) => void;
  cellValidation: ValidationProps;
  rangeValidation: ValidationProps;
  translation: CompanyReportAdminTranslation;
}

export const SavedReportCellRange: React.FC<SavedReportCellRangeProps> = ({
  id, title, cellRequired, cellValue, rangeValue, onUpdateCell, onUpdateRange,
  cellValidation, rangeValidation, translation
}) => {

  return <div className={styles.wrapper}>
    <GroupText>{title}</GroupText>
    <div className={styles.container}>
      <div className="row">
        <div className="col-lg-6 col-sm-12">
          <Textarea
            componentId={getFieldId(id, cell)}
            onChange={onUpdateCell}
            value={cellValue}
            placeholder={translation.cell_placeholder}
            label={{ text: translation.cell, required: cellRequired }}
            validation={cellValidation}
            wait={SHORT_DEBOUNCE_TIME}
            maxLength={savedReportCellMaxLength} />
        </div>
        <div className="col-lg-6 col-sm-12">
          <Textarea
            componentId={getFieldId(id, range)}
            info={{ visible: true, text: translation.range_info_text }}
            onChange={onUpdateRange}
            value={rangeValue}
            label={{ text: translation.range }}
            validation={rangeValidation}
            wait={SHORT_DEBOUNCE_TIME}
            maxLength={savedReportRangeMaxLength} />
        </div>
      </div>
    </div>
  </div>;
};
